import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * ERV Icon Style03 - Air Purifier icon
 * 空氣清淨圖示 - 帶濾網的設備
 */
export const Style03_AirPurifier: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
  animated = false 
}) => {
  const sizeInPx = getSizeInPixels(size);
  const primaryColor = isOn ? '#2dd4bf' : '#64748b'; // teal-400 : slate-500
  const accentColor = isOn ? '#22d3ee' : '#475569'; // cyan-400 : slate-600
  
  return (
    <svg
      viewBox="0 0 24 24"
      width={sizeInPx}
      height={sizeInPx}
      fill="none"
      className={`${className} ${animated && isOn ? 'animate-pulse' : ''}`}
    >
      {/* Device body */}
      <rect
        x="5"
        y="3"
        width="14"
        height="18"
        rx="3"
        stroke={primaryColor}
        strokeWidth="1.5"
        fill="none"
      />
      
      {/* Vent lines (air output) */}
      <line x1="8" y1="7" x2="16" y2="7" stroke={accentColor} strokeWidth="1.5" strokeLinecap="round" />
      <line x1="8" y1="10" x2="16" y2="10" stroke={accentColor} strokeWidth="1.5" strokeLinecap="round" />
      <line x1="8" y1="13" x2="16" y2="13" stroke={accentColor} strokeWidth="1.5" strokeLinecap="round" />
      
      {/* Control panel */}
      <circle
        cx="12"
        cy="18"
        r="1.5"
        fill={isOn ? '#4ade80' : '#64748b'}
      />
    </svg>
  );
};

export default Style03_AirPurifier;
